exports.list = {
    path: '/laba_rugi',
    name: 'laba_rugi', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laba_rugi/List.vue"),
  }
  